import React from "react";
import Header from "../sections/Header";
import Service from "../sections/Service";
import About from "../sections/About";
import Portfolio from "../sections/Portfolio";
import Blog from "../sections/Blog";
import Contact from "../sections/Contact";
import Footer from "../sections/Footer";

const Landing = () => {
  return <>
      <Header />
      <Service />
      <About />
      <Portfolio />
      <Blog />
      <Contact />
      <Footer />
    </>
 

}

export default Landing;
